export { locale } from './locale';

export * from './config';

export { uploadImageToServer, choosePhotoByApp, choosePhotoByWx } from './imgUploadUtil';

export { getRecaptchaJsUri, setRecaptchaJsLoaded, getRecaptchaJsLoaded } from './recaptcha';

export { rotateImg, getBosUrlRotateSum, getAwsUrlRotateSum } from './imgRotateUtil';

export * from './umuUtil';
export{ postMessageWithOldTab,postMessageWithOtherTab } from './postMessageWithNewTab'

/**
 * userAchievementUtil
 */
export {
    getMedalIcon,
    getUserLevelColorScheme,
    displayUserLevel,
    isFullUserLevel,
    FULL_USER_LEVEL,
    MEDAL_SIZE,
} from './userAchievementUtil';

export function removeElementsByClass(className: string) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
        if (elements[0] && elements[0].parentNode) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    }
}
